import { useState } from 'react';

import type { ReactNode } from 'react';

import { CreateCourseModalContainer } from '@treneo/features/courses';

import { Navbar } from './navbar/navbar';
import { ApplicationWrapper, ContentWrapper } from './app-layout.styles';
import { Footer } from './footer';

type Props = {
  isForLogged: boolean;
  children: ReactNode;
};

export const AppLayout = ({ isForLogged, children }: Readonly<Props>) => {
  const [showCreateCourseModal, setShowCreateCourseModal] = useState(false);

  const handleOpenCreateCourseModal = () => {
    setShowCreateCourseModal(true);
  };

  const handleCloseCreateCourseModal = () => {
    setShowCreateCourseModal(false);
  };

  return (
    <ApplicationWrapper>
      <Navbar isForLogged={isForLogged} onCreateCourse={handleOpenCreateCourseModal} />
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />

      <CreateCourseModalContainer
        open={showCreateCourseModal}
        onClose={handleCloseCreateCourseModal}
      />
    </ApplicationWrapper>
  );
};
